import React from 'react';
import Text from '../../molecules/Text';

import { addons } from '@data/mirage/mock/property-1';
import { AddonList } from '@data/models';

import { Flex, Spacer, Box, Divider } from '@chakra-ui/react';
import AddonCard from '@view/components/Cards/Addon';

function createMockAddon() {
  const list = new AddonList(addons);
  return list.items[0];
}

const DemoCard = () => {
  return (
    <Box>
      <h2>Card</h2>
      <Divider m={2} />
      <Flex align={'center'}>
        <AddonCard item={createMockAddon()} />
      </Flex>
    </Box>
  );
};

export default DemoCard;
